@if (component.data$ | async; as data) {
  <cx-media [container]="data.media"></cx-media>
}
